import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Tooltip } from "@mui/material";
import { styled } from "@mui/system";
import BryxBox from "./BryxBox";
import SvgIcon from "@mui/material/SvgIcon";
import BryxColors from "../types/theme";
const chipStyleMapping = (style, palette) => {
    switch (style) {
        case "selected":
            return {
                border: `2px solid ${BryxColors.brandPrimary(palette)}`,
                backgroundColor: "transparent !important",
            };
        case "completed":
            return {
                border: `2px solid ${BryxColors.brandPrimary(palette)}`,
                backgroundColor: `${BryxColors.brandPrimary(palette)} !important`,
            };
        case "error":
            return {
                height: "16px",
                border: `2px solid ${BryxColors.notify("dark", "error")}`,
                backgroundColor: `${BryxColors.notify("dark", "error")} !important`,
            };
        case "errorSelected":
            return {
                height: "16px",
                border: `2px solid ${BryxColors.notify("dark", "error")}`,
                backgroundColor: `transparent !important`,
            };
        default:
            return {
                border: `1px solid ${BryxColors.notify(palette, "inactive")}`,
                backgroundColor: "transparent !important",
            };
    }
};
const ProgressChip = styled(Chip)(({ theme, className }) => {
    const palette = theme.palette.mode;
    return {
        "& .MuiChip-label": {
            padding: "0px 0px 0px 0px",
        },
        boxShadow: "none !important",
        height: "12px",
        width: "25px",
        borderRadius: "4px",
        ...chipStyleMapping(className, palette),
    };
});
const BryxProgress = styled((props) => {
    return (_jsx(BryxBox, { isFlex: true, fullWidth: true, centerAlignItems: true, sx: { gap: "8px", height: "16px" }, children: props.progressChips.map((chipData, chipKey) => {
            let chipStyling = "default";
            if (chipData.completed) {
                chipStyling = "completed";
            }
            if (chipData.errored) {
                chipStyling = "error";
            }
            if (props.selected == chipKey) {
                chipStyling = "selected";
            }
            if (props.selected == chipKey && chipData.errored) {
                chipStyling = "errorSelected";
            }
            return (_jsx(Tooltip, { title: chipData.label, arrow: true, children: _jsx(ProgressChip, { className: chipStyling, onClick: () => props.onClick(chipKey), label: chipData.errored ? (_jsxs(SvgIcon, { viewBox: "0 0 3 10", sx: {
                            width: "3px",
                            height: "10px",
                        }, children: [_jsx("line", { x1: "1.5", y1: "1", x2: "1.5", y2: "5", stroke: chipStyling == "errorSelected" ? BryxColors.notify("dark", "error") : "white", strokeWidth: "2", strokeLinecap: "round" }), _jsx("rect", { x: "0.5", y: "8", width: "2", height: "2", rx: "0.5", fill: chipStyling == "errorSelected" ? BryxColors.notify("dark", "error") : "white" })] })) : undefined }, chipKey) }, chipKey));
        }) }));
})(({ theme }) => {
    // stub
    return {};
});
export default BryxProgress;
